import { Box } from "@mui/material";

const RequiredAsterisk = () => {
  return (
    <Box component="span" sx={{ color: "error.main", ml: 0.5 }}>
      *
    </Box>
  );
};

export default RequiredAsterisk;
